import { FC } from "react";
import { GenericAppThemeProperty } from "../Types";
import ChartPropertyCard from "../Cards/ChartPropertyCard";
import { Grid } from "@material-ui/core";

type ChartPropertiesListProps = {
  propertiesList: GenericAppThemeProperty[];
  isDarkFilter: boolean;
};

const ChartPropertiesList: FC<ChartPropertiesListProps> = ({ propertiesList, isDarkFilter }) => {
  const filteredProps = propertiesList.filter(x => x.isDark === isDarkFilter)
  .sort((a, b) => {
      const indexA = a.index ?? Number.MAX_SAFE_INTEGER;
      const indexB = b.index ?? Number.MAX_SAFE_INTEGER;
      return indexA - indexB;
    });
  return (
    <>
      <Grid container spacing={2} sx={{ padding: '1%' }}>
        {filteredProps.map((property) => (
          <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={property.themePropertyKey}>
            <ChartPropertyCard property={property} key={property.themePropertyKey} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ChartPropertiesList;
